export const link = (text, attrs) => {
  return `[${text}|${attrs.href}]`;
};